// Campus photo for /colleges/university-of-utah: CC BY-SA 4.0, by MrSchmidt, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUniversity_of_Utah_Presidents_Circle_.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-utah/; credited under the photo.
const photo = {
    "slug": "university-of-utah",
    "alt": "Autumn trees around Presidents Circle at the University of Utah, with the Wasatch foothills beyond",
    "src": "/colleges/university-of-utah/campus-1600.webp",
    "srcSmall": "/colleges/university-of-utah/campus-800.webp",
    "srcMid": "/colleges/university-of-utah/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-utah/og.jpg",
    "title": "University of Utah Presidents Circle ",
    "author": "MrSchmidt",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUniversity_of_Utah_Presidents_Circle_.jpg",
    "read": "2026-10-01"
};

export default photo;
